<template>
<m-pageframe
  :title="title"
  :color="pageframe_color"
>
<v-container>
    
    <m-contact-request-card
        v-if="contact_request != null"
        :contact_request="contact_request"
        v-on:search="updateContactRequest();"
    />

</v-container>

</m-pageframe>
</template>

<script>

export default {
    data() {
        return {
            contact_request: null,
        }
    },

    created () {
        this.$event_bus.$on('upsert-contact-request', this.onUpsertContactRequest);
    },

    beforeDestroy () {
        this.$event_bus.$off('upsert-contact-request',this.onUpsertContactRequest);
    },

    mounted () {
        this.updateContactRequest();
    },

    methods: {
        onUpsertContactRequest(contact_request_id) {
            if ( this.contact_request == null ) return;
            if ( this.contact_request.contact_request_id != contact_request_id ) return;
            
            this.updateContactRequest();
        },

        updateContactRequest()
        {
            this.$rc.showSpinner();

            this.$rc.getContactRequest(
                this.$route.params.contact_request_id, 

                (data) => {
                    this.$rc.hideSpinner();

                    this.contact_request = data.contact_request;
                },

                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error', 'Unable to load contact request.');
                    this.$router.push({'name': 'home'}).catch(e=>{}); // swallow any exception
                }
            );
        },
    },

    computed: {
        title() {
            if ( this.contact_request == null ) return "Contact Request";
            return "Contact "+this.contact_request.customer_name;
        },

        pageframe_color() {
            let primary = '#F24653';
            let gray = '#5D647C';

            if ( this.contact_request == null ) return primary;
            if ( this.contact_request.assignment_type != 'assigned-to-employee' ) return primary;
            if ( this.contact_request.assignment_id != this.$rc.$state.employee_id ) return gray;

            return primary;
        },
    },
}
</script>

<style lang="scss" scoped>
</style>